import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button, Form, Modal } from 'react-bootstrap';
import { BarLoader } from 'react-spinners';
import { IoAddOutline, IoSearch } from 'react-icons/io5';
import OutletHead from '../../../../components/common/outlet-head';
import UserRoleDataTable from '../../../../components/datatables/user-roles';
import UserRoleForm from '../../../../components/forms/user-roles';
import { toast } from 'react-toastify';
import { useAuth } from '../../../../context/AuthContext';

function ManageUsers() {
  const { user } = useAuth();
  const { bid, businessProfile } = user.claims;


  const [isLoading, setIsLoading] = useState(true);
  const [isSwitching, setIsSwitching] = useState(null);
  const [data, setData] = useState(null);
  const [showAddUser, setShowAddUser] = useState(false);

  const handleClose = () => setShowAddUser(false);
  const handleShow = () => setShowAddUser(true);

  async function listAllUsers(accessToken, uid) {
    let config = {
      method: 'get',
      url: `${process.env.REACT_APP_FIREBASE_FUNCTIONS}/business-users`,
      headers: {
        "idToken": accessToken,
        "uid": uid,
        "bid": bid
      }
    };

    axios.request(config)
      .then((response) => {
        if (response.status === 200) {
          setData(response.data);
          setIsLoading(false);
        }
      }).catch((error) => {
        console.log('Error :', error);
        setIsLoading(false);
      });
  }

  useEffect(() => {
    const { accessToken, uid } = user;

    if (user) {
      listAllUsers(accessToken, uid);
    }
  }, [user]);

  const handleRoleData = (data) => {
    const { accessToken, uid } = user;

    let config = {
      method: 'post',
      url: `${process.env.REACT_APP_FIREBASE_FUNCTIONS}/create-user`,
      headers: {
        "idToken": accessToken,
        "uid": uid,
        "bid": bid
      },
      data: data
    };

    axios.request(config)
      .then((response) => {
        if (response.status === 201) {
          toast.success(response.data.message);
          listAllUsers(accessToken, uid);
          handleClose();
        }
      }).catch((error) => {
        toast.error(error && error.message);
      });
  }

  const handleEnableDisable = (userId, value) => {
    setIsSwitching(userId);
    const { accessToken, uid } = user;
    let config = {
      method: 'post',
      url: `${process.env.REACT_APP_FIREBASE_FUNCTIONS}/updateUserStatus`,
      headers: {
        "idToken": accessToken,
        "uid": uid
      },
      data: {
        uid: userId,
        disabled: value
      }
    };

    axios.request(config)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.userData.disabled) {
            toast.error('User disabled!');
            listAllUsers(accessToken, uid);
          } else {
            toast.success('User enabled!');
          }
          setTimeout(() => {
            setIsSwitching(null);
          }, 1000);
        }
      }).catch((error) => {
        toast.error(error.response.data.message);
      });
  }

  return (
    <section className='section'>
      <OutletHead
        left={
          <div className='custom-header'>
            <h5 className='mb-0 fw-600'>Manage Users</h5>
            <p className='mb-0 text-muted'>
              <small>Give access to users and monitor their actions</small>
            </p>
          </div>
        }
        right={
          <div className='d-flex align-items-center justify-content-end'>
            <Button
              variant="primary"
              className='py-2 px-4 btn-width'
              onClick={handleShow}
            >
              <IoAddOutline size={21} />
              <span className='ps-2'>Add User</span>
            </Button>
          </div>
        }
      />
      <div className='p-3 position-relative border-top'>
        <div className='row'>
          <div className='col-lg-12'>
            {
              isLoading ?
                <div className='data-loading-container'>
                  <div className='loader'>
                    <BarLoader color={`var(--bs-primary)`} />
                  </div>
                </div>
                :
                <div className='mb-5'>
                  <div className='pb-3'>
                    <Form onSubmit={null}>
                      <div className='row'>
                        <div className='col-md-6 col-12'>
                          <div className='position-relative'>
                            <div className='position-absolute left-0 top-0 bottom-0 ps-3 d-flex align-items-center justify-content-center'>
                              <IoSearch size={20} color={`var(--bs-placeholder)`} />
                            </div>
                            <Form.Control
                              type="text"
                              placeholder="Search users"
                              onChange={(e) => null}
                              className='ps-5'
                            />
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>
                  <UserRoleDataTable
                    columns={['#', 'Display Name', 'Email', '', 'Roles', '']}
                    data={data}
                    isSwitching={isSwitching}
                    handleEnableDisable={handleEnableDisable}
                  />
                </div>
            }
          </div>
        </div>
      </div>

      <Modal
        show={showAddUser}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Role</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UserRoleForm handleClose={handleClose} handleRoleData={handleRoleData} />
        </Modal.Body>
      </Modal>
    </section>
  );
}

export default ManageUsers;